import {
  primaryColor,
  fontColor,
  webFont,
  textBlack
} from "../../config/theme";

const style = {
  setFont: {
    fontFamily: webFont
  },
  heavy: {
    fontWeight: 500
  },
  headerFont: {
    fontSize: 30
  },
  whiteFont: {
    color: fontColor
  },
  opacityUnset: {
    opacity: "unset"
  },
  stepText: {
    fontSize: 19,
    fontWeight: 500,
    color: primaryColor,
    fontFamily: webFont,
    display: 'flex',
    alignItems: 'center',
  },
  stepSelected: {
    fontSize: 19,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '18.5px 0',
  },
  stepUnselected: {
    opacity: 0.3,
    fontSize: 17,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont
  },
  centerGrid: {
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontFamily: webFont,
    color: '#324148',
    fontSize: 18,
    marginTop: 30,

  },
  getStarted: {
    textDecoration: "none",
    color: fontColor,
    backgroundColor: primaryColor,
    borderRadius: "40px",
    fontFamily: webFont,
    padding: "12px 30px",
    fontWeight: 500,
    fontSize: 18,
    textTransform: "none",
    lineHeight: '32px',
    minWidth: 240,
  },
  specialDiv: {
    backgroundColor: "#f7f7f7",
    padding: "50px 0px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontFamily: webFont,
    color: textBlack,
  },
  subscribeBtn: {
    color: fontColor,
    padding: "10px 20px",
    borderRadius: "0px",
    fontFamily: webFont,
    textTransform: "capitalize",
    position: "relative",
    left: "-2px",
    top: 0,
    fontWeight: 'normal',
    fontSize: 18,
    boxShadow: 'none'
  },
  subscribeBtnTablet: {
    color: fontColor,
    padding: "12.5px 20px",
    borderRadius: "0px",
    fontFamily: webFont,
    marginTop: 1,
    textTransform: "capitalize",
  },
  subscribeField: {
    marginTop: "2px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "8px 10px",
    fontFamily: webFont,
    textTransform: "capitalize",
  },
  topButton: {
    minWidth: 180,
    height: 44,
    borderRadius: 22,
    textTransform: 'none',
    color: '#fff'
  },
  changePasswordButton: {
    borderRadius: 20,
    backgroundColor: "white",
    width: "200px",
    color: primaryColor,
    borderColor: primaryColor,
    height: 40,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "500",
    margin: "17px 150px 0 0"
  },
  becomeChefButton: {
    borderRadius: 25,
    color: "white",
    minWidth: 184,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    height: 40,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    margin: "0 0 14px"
  },
  becomeChefButtonTab: {
    borderRadius: 25,
    color: "white",
    minWidth: 200,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    margin: "0 0 14px"
  }
};

export default style;
